export const TemperatureScaleSign = {
  CELCIUS: 'C',
  FARENHEIT: 'F',
}
